module.exports = __webpack_public_path__ + "img/riks-logo.e23123f4.png";